import {
  CustomerOrderListPage,
  CustomerOrderItemScraperListPage
} from 'domains/customer-order'

import {
  CustomerRefundShipmentListPage,
  CustomerRefundShipmentCreatePage,
  CustomerRefundShipmentDetailPage
} from 'domains/customer-refund-shipment'

import {
  SellerOutboundReturnDetailPage,
  SellerOutboundReturnCreatePage,
  SellerOutboundReturnListPage
} from 'domains/seller-outbound-return/pages'
import {
  MerchantInboundRejectReturnListPage,
  MerchantInboundRejectReturnDetailPage
} from 'domains/merchant-inbound-reject-return/pages'
import {
  MerchantOutboundReturnListPage,
  MerchantOutboundReturnDetailPage,
  MerchantOutboundReturnCreatePage
} from 'domains/merchant-outbound-return/pages'

import outbound_team_seller_marketproduct_routes from './seller-market'

import {
  CustomerShipmentRequestPickupPage,
  CustomerShipmentListPage
} from 'domains/customer-shipment'
import { OutboundDealsDetailPage, OutboundDealsListPage, OutboundShipmentListPage } from 'domains/outbound/deals/pages'

const outbound_team_routes = {
  collapse  : true,
  path      : '/outbound-team',
  name      : 'Outbound Team',
  icon      : 'fas fa-truck text-blue',
  state_key : 'outbound_team_collapse',
  views     : [
    {
      path      : '/outbound/deals/list',
      name      : 'Order List',
      miniName  : 'L',
      component : OutboundDealsListPage,
      layout    : '/app'
    },
    {
      path      : '/outbound/deals/list?scope=ready_to_ship',
      name      : 'Shipment List',
      miniName  : 'L',
      component : OutboundShipmentListPage,
      layout    : '/app'
    },
    {
      path      : '/outbound/deals/:id',
      name      : 'Deal Detail',
      miniName  : 'D',
      component : OutboundDealsDetailPage,
      layout    : '/app',
      invisible : true
    },
    // /** Customer Order List Page */
    // {
    //   path      : '/outbound-team/orders',
    //   name      : 'Orders',
    //   miniName  : 'O',
    //   component : CustomerOrderListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/customer-order-items/scrapers',
    //   name      : 'Order Item Scrapers',
    //   miniName  : 'SL',
    //   component : CustomerOrderItemScraperListPage,
    //   layout    : '/app'
    // },
    // /** Seller Outbound Returns */
    // {
    //   path      : '/seller-outbound-returns',
    //   name      : 'Seller Returns',
    //   miniName  : 'SR',
    //   component : SellerOutboundReturnListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/seller-outbound-returns/create',
    //   name      : 'Seller Create Returns',
    //   component : SellerOutboundReturnCreatePage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   path      : '/seller-outbound-returns/:id',
    //   name      : 'Seller Returns Detail',
    //   component : SellerOutboundReturnDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // /** Merchant Outbound Reject Returns */
    // {
    //   path      : '/merchants/outbounds/reject-returns/list',
    //   name      : 'Merchant Reject Returns',
    //   miniName  : 'MRR',
    //   component : MerchantInboundRejectReturnListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/merchants/outbounds/reject-returns/:id/detail',
    //   name      : 'Reject Return Detail',
    //   invisible : true,
    //   component : MerchantInboundRejectReturnDetailPage,
    //   layout    : '/app'
    // },
    // /** Merchant Outbound Returns */
    // {
    //   path      : '/merchants/outbounds/returns/list',
    //   name      : 'Merchant Returns',
    //   miniName  : 'MR',
    //   component : MerchantOutboundReturnListPage,
    //   layout    : '/app'
    // },
    // /** Customer Refund Request */
    // {
    //   path      : '/merchants/outbounds/returns/:id/detail',
    //   name      : 'Merchant Return Detail',
    //   layout    : '/app',
    //   component : MerchantOutboundReturnDetailPage,
    //   invisible : true
    // },
    // {
    //   path      : '/merchants/outbounds/returns/create',
    //   name      : 'Merchant Return Create',
    //   layout    : '/app',
    //   component : MerchantOutboundReturnCreatePage,
    //   invisible : true
    // },
    // {
    //   path      : '/refunds/shipments',
    //   name      : 'Refund Shipment',
    //   miniName  : 'RS',
    //   component : CustomerRefundShipmentListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/shipments',
    //   name      : 'Shipments',
    //   miniName  : 'SH',
    //   component : CustomerShipmentListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/shipments/request-pickup',
    //   name      : 'Request Pickup',
    //   miniName  : 'RP',
    //   component : CustomerShipmentRequestPickupPage,
    //   invisible : true,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/refunds/shipments/create',
    //   component : CustomerRefundShipmentCreatePage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   path      : '/refunds/shipments/:id',
    //   name      : 'Refund Shipment Detail',
    //   component : CustomerRefundShipmentDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   collapse  : true,
    //   name      : 'Marketplace Order',
    //   miniName  : 'SM',
    //   state_key : 'outbound_seller_market_collapse',
    //   views     : outbound_team_seller_marketproduct_routes
    // }
  ]
}

export default outbound_team_routes